import {api} from '../../utils/api'

export default {

    /**
     * load messaged
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadMessages({commit}, payload) {
        return api.call(commit, 'get', '/api/chat/history/'+payload.type+"/"+payload.id, null,  'SET_MESSAGES');
    },

    /**
     * Send message
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    sendMessage({commit}, payload) {
        return api.call(commit, 'post', '/api/chat/add/'+payload.type+"/" + payload.id, payload,  'SET_MESSAGES');
    },

    /**
     * Remove message
     * @param commit
     * @param id
     * @returns {*|Promise|Promise<any>}
     */
    removeMessage({commit}, id) {
        return api.call(commit, 'delete', `/api/chat/${id}`, id, 'REMOVE_MESSAGE');
    },

}
